module.exports = __webpack_public_path__ + "static/img/bg2.125566d0.png";